import { GraphNode } from "./OwnershipStructureTopDown";
import { PropertyInfoInterface } from "src/managers/PropertyInfoInterface";

export type NodeType = "Ejendom" | "Person" | "Firma" | "Aktieselskab" | "Link" | "AndenDeltager"

export type OwnerShipStructureData = {
   title: string,
   type: NodeType,
   ejere: OwnerShipInstance[]
}

export type OwnerShipInstance = {
   pct: string,
   ejer: OwnerShipStructureData
}

type Reverse = {
   data: {
      reverse: true,
   }
}

function nodeTypeFromEnhedsType(a: string): NodeType {
   return ({
      "VIRKSOMHED": "Firma",
      "ANDEN_DELTAGER": "AndenDeltager"
   } as const)[a] || "Person"

}

export async function buildOwnershipStructure(nodeType: NodeType, navn: string, id: number): Promise<GraphNode & Reverse> {
   switch (nodeType) {

      case "Ejendom":
         throw new Error("Not implemented yet");
         return {
            data: {
               title: navn,
               type: "Ejendom",
               countResult: { virksomheder: 0, ejendomme: 0, samletFastEjendom: 0, bygnFremmedGrund: 0, ejerlejlighed: 0 },
               lat: 0,
               lng: 0,
               entityId: id,
               expandedAsDefault: false,
               isCollapsed: true,
               pct: 0,
               ejendomsType: "",
               reverse: true,
            },
            children: []
         }

      case "AndenDeltager":
         return {
            data: {
               title: navn,
               type: "AndenDeltager",
               countResult: { virksomheder: 0, ejendomme: 0, samletFastEjendom: 0, bygnFremmedGrund: 0, ejerlejlighed: 0 },
               lat: 0,
               lng: 0,
               entityId: id,
               expandedAsDefault: false,
               isCollapsed: true,
               pct: 0,
               reverse: true,
               ejendomsType: "",
            },
            children: []
         }
      case "Person":
         return {
            data: {
               title: navn,
               type: "Person",
               countResult: { virksomheder: 0, ejendomme: 0, samletFastEjendom: 0, bygnFremmedGrund: 0, ejerlejlighed: 0 },
               lat: 0,
               lng: 0,
               entityId: id,
               expandedAsDefault: false,
               isCollapsed: true,
               pct: 0,
               reverse: true,
               ejendomsType: "",
            },
            children: []
         }

      case "Aktieselskab":
      case "Firma":
         let result3 = await PropertyInfoInterface.getCVRData(id as number);
         let keyData = PropertyInfoInterface.extractRelevantData(result3);
         let ej2: GraphNode[] = [];

         for (let i: number = 0; i < keyData.ejere.length; i++) {
            let ej = keyData.ejere[i];
            if (ej.forretningsnoegle == id) {
               continue;
            }
            let res = await buildOwnershipStructure(
               nodeTypeFromEnhedsType(ej.enhedstype),
               ej.navn,
               ej.forretningsnoegle || ej.cvrPersonId
            )
            ej2.push({ ...res, data: { ...res.data, pct: ej.andel } })
         }
         return {
            data: {
               title: keyData.navn,
               type: (keyData.navn as string).includes("ApS") ? "Firma" : "Aktieselskab",
               countResult: { virksomheder: 0, ejendomme: 0, samletFastEjendom: 0, bygnFremmedGrund: 0, ejerlejlighed: 0 },
               lat: 0,
               lng: 0,
               entityId: id,
               expandedAsDefault: false,
               isCollapsed: true,
               reverse: true,
               pct: 0,
               ejendomsType: ""
            },
            children: ej2
         }

      default:
         throw new Error("Unexpected state");
   }
}